import { styled } from '@mui/material/styles';

export const HeaderTechStyled = styled('header')`
  display: flex;
  height: 50px;
  padding: 16px 12px;
`;
